<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Define Assessment Scheme... </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <span v-if="card_load">
                        <v-row align="center" justify="center">
                            <template v-if="show_add_new_assessment_scheme">
                                <template v-if="assessment_scheme_list != null">
                                    <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                                        <v-autocomplete
                                            dense
                                            required
                                            outlined
                                            rounded
                                            color="#0F2027"
                                            v-model="assessment_scheme"
                                            :items="assessment_scheme_list"
                                            item-text="name"
                                            item-value="id"
                                            label="Assessment Scheme"
                                            persistent-hint
                                            hint="Please select assessment scheme"
                                            @change="getAssessmentDetails()"
                                        />
                                    </v-col>
                                </template>
                                <v-col cols="12" sm="4" md="4" class="pt-0 m-0">
                                    <v-btn dense outlined rounded class="button" @click="show_add_new_assessment_scheme = false">Add New</v-btn>
                                </v-col>
                            </template>
                            <template v-else>
                                <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                                    <v-text-field color="#0F2027" rounded outlined dense label="Add Assessment Scheme" placeholder="Scheme 1" v-model.trim="new_assessment_scheme"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" class="pt-0 m-0">
                                    <v-btn style="margin: 5px;" class="button" outlined rounded :loading="add_new_ass_sch_btn" @click="addNewAssessmentScheme">Save</v-btn>
                                    <v-btn dense class="button" outlined rounded @click="show_add_new_assessment_scheme = true">Cancel</v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </span>
                </v-col>
            </v-card>
            <v-card class="box" :loading="ass_det_card" v-if="assessment_scheme != null">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Assessment Scheme Details </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <template v-if="assessment_type_list != ''" class="p-0 m-0">
                        <v-row dense justify="center">
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete
                                    color="#0F2027"
                                    dense
                                    outlined
                                    rounded
                                    required
                                    return-object
                                    v-model="assessment_type"
                                    :items="assessment_type_list"
                                    item-text="name"
                                    label="Assessment Type"
                                    persistent-hint
                                    hint="Please select assessment type"
                                    @change="ass_type_formula=null"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete
                                    dense
                                    outlined
                                    rounded
                                    required
                                    return-object
                                    v-model="evaluation_type"
                                    :items="evaluation_type_list"
                                    item-text="name"
                                    label="Evaluation Type"
                                    persistent-hint
                                    hint="Please select evaluation type"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete
                                    dense
                                    outlined
                                    rounded
                                    required
                                    return-object
                                    v-model="ass_type_formula"
                                    :items="ass_details_formula_list"
                                    item-text="name"
                                    label="Assessment Type Formula"
                                    persistent-hint
                                    hint="Select  assessment type formula"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3" v-if="ass_details_group_list != ''">
                                <v-autocomplete
                                    dense
                                    outlined
                                    rounded
                                    required
                                    return-object
                                    v-model="ass_type_group"
                                    :items="ass_details_group_list"
                                    item-text="groupname"
                                    label="Assessment Type Group"
                                    persistent-hint
                                    hint="Select  assessment type group"
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field color="#0F2027" label="Evaluated Marks" dense outlined rounded placeholder="30" type="number" v-model="evaluated_marks"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field color="#0F2027" label="Converted Marks" outlined rounded placeholder="10" type="number" dense v-model="converted_marks"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field color="#0F2027" label="Passing Marks %" outlined rounded placeholder="40" type="number" dense v-model.trim="passing_marks"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field color="#0F2027" label="Sort Order" outlined rounded placeholder="0" type="number" dense v-model.trim="sort_order"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field color="#0F2027" label="Display Name" outlined rounded dense v-model.trim="display_name"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-checkbox class="mt-none pt-none ml-9" v-model="showinmarksheet" color="#0F2027" label="Whether this scheme show in marksheet?"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-checkbox class="mt-none pt-none ml-9" v-model="isderived" color="#0F2027" label="Whether this field is derived?"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-checkbox class="mt-none pt-none ml-9" v-model="showinparentmarksheet" color="#0F2027" label="Whether this scheme show in parent marksheet?"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn dense class="button" rounded outlined :disabled="edit_flag == false ? true : false" @click="addAssessmentDetails">Add</v-btn>
                        </v-row>
                    </template>
                    <v-row class="p-0 m-0" v-if="assessment_scheme != null">
                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                            <v-row dense>
                                <v-text-field dense rounded outlined v-model="assement_scheme_name" label="Change Scheme Name" single-line hide-details></v-text-field>
                                <v-btn class="button" v-if="assement_scheme_name" small @click="editSchemeName()">Edit</v-btn>
                            </v-row>
                        </v-col>
                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                        </v-col>
                    </v-row>
                    <v-data-table
                        v-if="
              assessment_scheme_details_list != '' && assessment_scheme != null
            "
                        dense
                        :headers="headers"
                        :items="assessment_scheme_details_list"
                        :search="search"
                        class="elevation-1 mytable"
                    >
                        <template v-slot:item.options="{ item }">
                            <v-row>
                                <v-avatar size="33" class="edit-avatar p-3 m-2">
                                    <v-icon :disabled="edit_flag == false ? true : false" class="edit-v-icon" color="#0F2027" @click="editItem(item)">edit</v-icon>
                                </v-avatar>
                                <v-tooltip top color="gray">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-avatar size="33" v-if="item.delete == 'NO'">
                                            <v-icon class="mr-2" v-bind="attrs" v-on="on" color="gray" title="Delete Scheme">delete</v-icon>
                                        </v-avatar>
                                    </template>
                                    <span> This scheme is offer so you cannot delete it. </span>
                                </v-tooltip>
                                <v-avatar size="33" class="delete-avatar" v-if="item.delete == 'YES'">
                                    <v-icon class="mr-2 delete-v-icon" color="red" @click="deleteass(item.asd_id)" title="Delete Scheme">delete</v-icon>
                                </v-avatar>
                            </v-row>
                        </template>
                        <template v-slot:item.isderived="{ item }">
                            <span v-if="item.isderived">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                        <template v-slot:item.showinmarksheet="{ item }">
                            <span v-if="item.showinmarksheet">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                         <template v-slot:item.showinparentmarksheet="{ item }">
                            <span v-if="item.showinparentmarksheet">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                    </v-data-table>
                    <v-dialog v-model="dialog_delete_que" persistent max-width="500px">
                        <v-card>
                            <v-container>
                                <v-card class="box">
                                    <input type="hidden" v-model="deleteItem.delete_id" />
                                    <strong>Are you sure you want Delete Assessment Scheme Details??</strong>
                                    <v-row justify="center">
                                        <v-btn class="button" text @click="dialog_delete_que = false">No</v-btn>
                                        <v-btn class="button" text @click="deletescheme()">Yes</v-btn>
                                    </v-row>
                                </v-card>
                            </v-container>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog_edit" persistent max-width="1300px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Edit Assessment Scheme Details </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-card class="box">
                                    <v-row justify="center">
                                        <!-- {{editeditem}} -->
                                        <!-- "srno": 1, "asd_id": 1, "delete": "NO", "as_id": 4, "assessmenttype": "Class Test",
                                  "evaluationtype": "Formative", "evaluated_marks": 30, 
                                  "converted_marks": 10, "passing_marks": 15 } -->
                                        <v-col cols="12" sm="3" md="3">
                                            <v-autocomplete color="#0F2027" dense outlined rounded required item-value="name" v-model="editeditem.assessmenttype" :items="assessment_type_list" item-text="name" label="Assessment Type" />
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3">
                                            <v-autocomplete dense outlined rounded required item-value="name" v-model="editeditem.evaluationtype" :items="evaluation_type_list" item-text="name" label="Evaluation Type" />
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3">
                                            <v-autocomplete
                                                dense
                                                outlined
                                                rounded
                                                required
                                                item-value="name"
                                                v-model="editeditem.assessmentDetailsformula"
                                                :items="ass_details_formula_list"
                                                item-text="name"
                                                label="Assessment Type Formula"
                                                clearable
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3" v-if="ass_details_group_list != ''">
                                            <v-autocomplete
                                                dense
                                                outlined
                                                rounded
                                                required
                                                item-value="groupname"
                                                v-model="editeditem.assessmentDetailsgroup"
                                                :items="ass_details_group_list"
                                                item-text="groupname"
                                                label="Assessment Type Group"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-text-field color="#0F2027" label="Evaluated Marks" dense outlined rounded placeholder="30" type="number" v-model="editeditem.evaluated_marks"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-text-field color="#0F2027" label="Converted Marks" outlined rounded placeholder="10" type="number" dense v-model="editeditem.converted_marks"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-text-field color="#0F2027" label="Passing Marks %" outlined rounded placeholder="40" type="number" dense v-model.trim="editeditem.passing_marks"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-text-field color="#0F2027" label="Sort Order" outlined rounded placeholder="1" type="number" dense v-model.trim="editeditem.sort_order"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                            <v-text-field color="#0F2027" label="Display Name" outlined rounded dense v-model.trim="editeditem.display_name"></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="3" md="3">
                                            <v-checkbox class="mt-none pt-none ml-9" v-model="editeditem.isderived" color="#0F2027" label="Whether this field is derived?"></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3">
                                            <v-checkbox class="mt-none pt-none ml-9" v-model="editeditem.showinmarksheet" color="#0F2027" label="Whether this scheme show in marksheet?"></v-checkbox>
                                        </v-col>
                                         <v-col cols="12" sm="3" md="3">
                                            <v-checkbox class="mt-none pt-none ml-9" v-model="editeditem.showinparentmarksheet" color="#0F2027" label="Whether this scheme show in parent marksheet?"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-btn rounded class="button mr-1" @click="save_scheme">Update</v-btn>
                                        <v-btn rounded class="button" @click="dialog_edit = false">Close</v-btn>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-card>
                    </v-dialog>
                </v-card-text>
            </v-card>
        </v-col>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data() {
            return {
                assessment_scheme_list: null,
                assessment_scheme: null,
                assessment_type_list: [],
                assessment_type: null,
                evaluation_type_list: null,
                evaluation_type: null,
                card_load: false,
                show_add_new_assessment_scheme: true,
                new_assessment_scheme: null,
                add_new_ass_sch_btn: false,
                snackbar_msg: null,
                snackbar: false,
                color: "",
                assessment_scheme_details_list: [],
                ass_details_formula_list: null,
                ass_details_group_list: [],
                ass_type_formula: null,
                ass_type_group: null,
                ass_det_card: false,
                evaluated_marks: 0,
                converted_marks: 0,
                passing_marks: 0,
                sort_order: 0,
                search: null,
                dialog_delete_que: false,
                dialog_edit: false,
                showinmarksheet: true,
                showinparentmarksheet: true,
                isderived: false,
                editedIndex: -1,
                editeditem: [],
                assement_scheme_name: null,
                display_name:null,
                edit_flag: null,
                deleteItem: {
                    delete_id: "",
                },
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Assessment Type",
                        align: "left",
                        sortable: false,
                        value: "assessmenttype",
                    },
                                        {
                        text: "Display Name",
                        align: "left",
                        sortable: false,
                        value: "display_name",
                    },
                    {
                        text: "Evaluation Type",
                        align: "left",
                        sortable: false,
                        value: "evaluationtype",
                    },
                    {
                        text: "Assessment Type Formula",
                        align: "left",
                        sortable: false,
                        value: "assessmentDetailsformula",
                    },
                    {
                        text: "Assessment Type Group",
                        align: "left",
                        sortable: false,
                        value: "assessmentDetailsgroup",
                    },
                    {
                        text: "Evaluated Marks",
                        align: "left",
                        sortable: false,
                        value: "evaluated_marks",
                    },
                    {
                        text: "Converted Marks",
                        align: "left",
                        sortable: false,
                        value: "converted_marks",
                    },
                    {
                        text: "Passing Marks %",
                        align: "left",
                        sortable: false,
                        value: "passing_marks",
                    },
                    {
                        text: "Sort order",
                        align: "left",
                        sortable: false,
                        value: "sort_order",
                    },
                    {
                        text: "Is Derived",
                        align: "left",
                        sortable: false,
                        value: "isderived",
                    },
                    {
                        text: "Show In Marksheet",
                        align: "left",
                        sortable: false,
                        value: "showinmarksheet",
                    },
                    {
                        text: "Show In Parent Marksheet",
                        align: "left",
                        sortable: false,
                        value: "showinparentmarksheet",
                    },

                    {
                        text: "Action",
                        sortable: false,
                        value: "options",
                    },
                ],
            };
        },
        methods: {
            editItem(item) {
                this.editeditem = Object.assign({}, item);
                this.dialog_edit = true;
            },
            deleteass(item) {
                this.dialog_delete_que = true;
                this.deleteItem.delete_id = item;
            },
            deletescheme() {
                const formData = {
                    assessment_scheme: this.deleteItem.delete_id,
                };
                axios
                    .post("/examination/deleteAssessmentScheme", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Assessment Scheme Details Deleted Successfully");
                            this.getAssessmentDetails();
                            this.dialog_delete_que = false;
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                        this.dialog_delete_que = false;
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editSchemeName() {
                if (this.assement_scheme_name == null || this.assement_scheme_name == "") {
                    this.showSnackbar("#b71c1c", "Please Add Assessment Scheme Name!!!");
                    return;
                }
                const data = {
                    assement_scheme_name: this.assement_scheme_name,
                    assessment_scheme: this.assessment_scheme,
                };
                axios
                    .post("/examination/editSchemeName", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Assessment Scheme edited Successfully");
                            this.getAssessmentDetails();
                            // alert("after save")
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            save_scheme() {
                let evaluated_marks = 0;
                let converted_marks = 0;
                let passing_marks = -1;
                let sort_order = 0;
                // alert(this.editeditem.sort_order)
                // alert(this.editeditem.evaluated_marks)
                // alert(this.editeditem.converted_marks)
                // alert(this.editeditem.passing_marks)
                evaluated_marks = parseFloat(this.editeditem.evaluated_marks);
                converted_marks = parseFloat(this.editeditem.converted_marks);
                passing_marks = parseFloat(this.editeditem.passing_marks);
                sort_order = parseInt(this.editeditem.sort_order);
                if (isNaN(evaluated_marks) || isNaN(converted_marks) || isNaN(passing_marks) || isNaN(sort_order)) {
                    alert("Please add marks");
                    return;
                }
                if (
                    //  evaluated_marks < converted_marks ||
                    evaluated_marks < 0 ||
                    converted_marks < 0 ||
                    passing_marks < 0 ||
                    sort_order < 0
                ) {
                    alert("Please add valid marks");
                    return;
                }
                const formData = {
                    evaluated_marks: evaluated_marks,
                    converted_marks: converted_marks,
                    passing_marks: passing_marks,
                    sort_order: sort_order,
                    isderived: this.editeditem.isderived,
                    editeditem: this.editeditem,
                    showinmarksheet: this.editeditem.showinmarksheet,
                    showinparentmarksheet: this.editeditem.showinparentmarksheet
                };
                axios
                    .post("/examination/editAssessmentDetials", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", "Assessment Scheme Details edited Successfully");
                                this.getAssessmentDetails();
                                this.dialog_edit = false;
                            }
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.dialog_edit = false;
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            addAssessmentDetails() {
                let evaluated_marks = 0;
                let converted_marks = 0;
                let passing_marks = -1;

                evaluated_marks = parseFloat(this.evaluated_marks);
                converted_marks = parseFloat(this.converted_marks);
                passing_marks = parseFloat(this.passing_marks);
                if (isNaN(evaluated_marks) || isNaN(converted_marks) || isNaN(passing_marks)) {
                    alert("Please add marks");
                    return;
                }
                if (
                    //   evaluated_marks < converted_marks ||
                    evaluated_marks < 0 ||
                    converted_marks < 0 ||
                    passing_marks < 0
                ) {
                    alert("Please add valid marks");
                    return;
                }
                let ass_type_grp 
                if(this.ass_type_group){
                    ass_type_grp = this.ass_type_group.id
                }
                 let ass_type_formula_id = null;
                    if (this.ass_type_formula) {
                        ass_type_formula_id = this.ass_type_formula.id;
                    }
                const formData = {
                    evaluated_marks: evaluated_marks,
                    converted_marks: converted_marks,
                    passing_marks: passing_marks,
                    assessment_type_id: this.assessment_type.id,
                    evaluation_type_id: this.evaluation_type.id,
                    assessment_scheme: this.assessment_scheme,
                    ass_type_formula: ass_type_formula_id,
                    ass_type_group: ass_type_grp,
                    isderived: this.isderived,
                    showinmarksheet: this.showinmarksheet,
                    display_name: this.display_name,
                    sort_order: this.sort_order,
                    showinparentmarksheet: this.showinparentmarksheet
                };
                console.log(formData);
                axios
                    .post("/examination/saveAssessmentDetials", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            if (res.data.flag == "NEW") {
                                this.showSnackbar("#4caf50", "Assessment Scheme  Details Added Successfully");
                                this.getAssessmentDetails();
                            } else if (res.data.flag == "Exist") {
                                this.showSnackbar("#b71c1c", "Assessment Scheme Details / Assessment Scheme type Already Exist!!...");
                                this.getAssessmentDetails();
                            }
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            getAssessmentDetails() {
                this.ass_det_card = true;
                const formData = {
                    assessment_scheme_id: this.assessment_scheme,
                };
                axios
                    .post("/examination/getAssessmentDetials", formData)
                    .then((res) => {
                        this.assessment_scheme_details_list = res.data.assessment_scheme_details_list;
                        this.ass_details_group_list = res.data.ass_details_group_list;
                        this.assessment_type_list = res.data.assessment_type_list;
                        this.evaluation_type = this.evaluation_type_list[0];
                        this.assessment_type = this.assessment_type_list[0];
                        // this.ass_type_formula = this.ass_details_formula_list[0];
                       //this.ass_type_group = this.ass_details_group_list[0];
                        this.assement_scheme_name = res.data.assement_scheme_name;
                        this.ass_det_card = false;
                        this.edit_flag = res.data.edit_flag;
                    })
                    .catch((error) => {
                      alert("error::"+error)
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.ass_det_card = false;
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            addNewAssessmentScheme() {
                if (this.new_assessment_scheme == null || this.new_assessment_scheme == "") {
                    this.showSnackbar("#b71c1c", "Please Add Assessment Scheme Name!!!");
                    return;
                }
                this.add_new_ass_sch_btn = true;
                const formData = {
                    new_assessment_scheme: this.new_assessment_scheme,
                };
                axios
                    .post("/examination/addAssessmentScheme", formData)
                    .then((res) => {
                        this.assessment_scheme_list = res.data.assessment_scheme_list;
                        if (res.data.status != "YES") {
                            alert(res.data.status);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.show_add_new_assessment_scheme = true;
                        this.add_new_ass_sch_btn = false;
                    });
            },
        },
        mounted() {
            this.card_load = false;
            axios
                .post("/examination/assessmentScheme")
                .then((res) => {
                    this.assessment_scheme_list = res.data.assessment_scheme_list;
                    this.assessment_type_list = res.data.assessment_type_list;
                    this.evaluation_type_list = res.data.evaluation_type_list;
                    this.ass_details_formula_list = res.data.ass_details_formula_list; 
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                    this.card_load = true;
                });
        },
    };
</script>
<style scoped>
    .button {
        border: 2px solid #0f2027 !important;
        color: #129fdc;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
    }
    .button:hover {
        color: white;
        background: #0f2027 !important;
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }

    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #0f2027 !important;
        margin: 0.2rem !important;
    }
    .edit-avatar:hover {
        background-color: transparent;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
